import { useEffect, useRef } from 'react';

const CleverCoreLoader = () => {
  const scriptLoadedRef = useRef(false); // Ref to track if script loading has been attempted

  useEffect(() => {
    // Prevent script from loading multiple times (e.g., due to React.StrictMode or re-renders)
    if (scriptLoadedRef.current || document.getElementById('CleverCoreLoader92394')) {
      //console.warn('CleverCore script already initiated or loaded.');
      return;
    }

    const loadScript = () => {
      const c = document.createElement('script');
      const f = window.frameElement;

      c.id = 'CleverCoreLoader92394';
      c.src = 'https://scripts.cleverwebserver.com/a502f3e0c1080f632ebfda7db2e37e40.js';
      c.async = true;
      c.type = 'text/javascript';
      c.setAttribute('data-cfasync', 'false'); // From your original script tag
      c.setAttribute('data-target', window.name || (f && f.getAttribute('id')) || '');

      // Optional: Handle script load success or error
      c.onload = () => {
        //console.warn('CleverCore script loaded successfully.');
        scriptLoadedRef.current = true; // Mark as loaded
      };

      c.onerror = () => {
        console.error('Failed to load CleverCore script.');
        // Potentially reset scriptLoadedRef.current to false if you want to allow retry on next mount
        // or handle the error appropriately.
      };

      let a;
      try {
        // Try to get the first script tag in the parent document or current document
        a = parent.document.getElementsByTagName('script')[0] || document.getElementsByTagName('script')[0];
      } catch {
        // If parent document access is restricted (e.g., cross-origin iframe) or no scripts exist
        a = document.getElementsByTagName('script')[0]; // Fallback to current document's scripts
      }

      if (!a) {
        // If no script tags are found, try to append to head or body
        a = document.getElementsByTagName('head')[0] || document.body; // document.body is a safe fallback
      }

      if (a && a.parentNode) {
        a.parentNode.insertBefore(c, a);
      } else if (a) {
        // If 'a' is head or body itself
        a.appendChild(c);
      } else {
        // Absolute fallback: append to documentElement if head/body somehow aren't found (very unlikely)
        document.documentElement.appendChild(c);
        console.warn(
          'CleverCoreLoader: Could not find a suitable script insertion point, appended to documentElement.',
        );
      }
    };

    loadScript();
    scriptLoadedRef.current = true; // Mark that an attempt to load has been made

    // No specific cleanup needed for this script as it's a one-time load
    // and doesn't seem to set up global event listeners that this component would manage.
    // If the script *did* have such things, you'd return a cleanup function here.
    return () => {
      // If you wanted to allow the script to be reloaded if the component is unmounted and remounted:
      // scriptLoadedRef.current = false;
      // However, for most third-party scripts that self-initialize, this is not necessary
      // and could lead to issues if the script isn't designed to be run multiple times.
    };
  }, []); // Empty dependency array ensures this effect runs only once after initial render

  // This component doesn't render any visible HTML itself, it just loads the script.
  // If you needed it to render a placeholder or some UI, you would add JSX here.
  return null;
};

export default CleverCoreLoader;
